var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowRightIcon = function SvgArrowRightIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3608 13.3849C14.4421 13.1338 14.4418 12.8634 14.36 12.6124C14.3285 12.5158 14.2609 12.3891 14.0743 12.1697C13.8819 11.9436 13.6103 11.6718 13.2052 11.2674L9.46408 7.53401C9.17089 7.24141 9.17041 6.76654 9.463 6.47335C9.75559 6.18015 10.2305 6.17967 10.5237 6.47226L14.2647 10.2057L14.2863 10.2272C14.6644 10.6045 14.98 10.9194 15.2168 11.1978C15.4637 11.4881 15.6688 11.7875 15.7861 12.1474C15.9661 12.6995 15.9668 13.2945 15.7879 13.847C15.6713 14.2071 15.4668 14.507 15.2205 14.7978C14.9842 15.0766 14.6693 15.3922 14.292 15.7703L14.2705 15.7918L10.537 19.5329C10.2444 19.8261 9.76956 19.8266 9.47637 19.534C9.18318 19.2414 9.18269 18.7665 9.47528 18.4733L13.2087 14.7323C13.6131 14.3271 13.8841 14.0547 14.076 13.8282C14.2622 13.6084 14.3295 13.4816 14.3608 13.3849Z",
    fill: "#22272F"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRightIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-right-icon.894da889.svg";
export { ForwardRef as ReactComponent };